var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMediumHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 54,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.378 52.78H58.52V2.774c0-.67.558-1.212 1.246-1.212h2.367c.687 0 1.245.542 1.245 1.212v50.008z",
    stroke: "#076447",
    strokeWidth: 1.182,
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M2.651 48.84H59.33v-19.7H2.65z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#076447",
    strokeWidth: 1.182,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.651 48.84H59.33v-19.7H2.65z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#076447",
    strokeWidth: 1.182,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M23.703 48.84h14.575v-19.7H23.703z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.826 27.818l-1.393-14.91c-.058-.624-.596-1.103-1.24-1.103H3.789c-.644 0-1.182.48-1.24 1.102L1.155 27.818c-.066.71.509 1.323 1.241 1.323h19.688v1.939c0 .67.558 1.212 1.246 1.212h15.322c.687 0 1.245-.542 1.245-1.212V29.14h19.688c.733 0 1.307-.612 1.241-1.323",
    fill: "#E1F8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.826 27.818l-1.393-14.91c-.058-.624-.596-1.103-1.24-1.103H3.789c-.644 0-1.182.48-1.24 1.102L1.155 27.818c-.066.71.509 1.323 1.241 1.323h19.688v1.939c0 .67.558 1.212 1.246 1.212h15.322c.687 0 1.245-.542 1.245-1.212V29.14h19.688c.733 0 1.307-.612 1.241-1.323z",
    stroke: "#076447",
    strokeWidth: 1.182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.14 52.78H1.842v-2.727c0-.67.558-1.212 1.245-1.212h55.807c.688 0 1.246.542 1.246 1.212v2.728z",
    fill: "#E1F8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.14 52.78H1.842v-2.727c0-.67.558-1.212 1.245-1.212h55.807c.688 0 1.246.542 1.246 1.212v2.728z",
    stroke: "#076447",
    strokeWidth: 1.182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.23 46.477h-6.478v-9.82c0-.67.558-1.212 1.246-1.212h3.986c.688 0 1.246.543 1.246 1.212v9.82z",
    fill: "#E1F8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.23 46.477h-6.478v-9.82c0-.67.558-1.212 1.246-1.212h3.986c.688 0 1.246.543 1.246 1.212v9.82z",
    stroke: "#076447",
    strokeWidth: 1.182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.41 42.537H7.945c-.688 0-1.246-.542-1.246-1.213v-3.88c0-.668.558-1.211 1.246-1.211h10.463c.688 0 1.246.543 1.246 1.212v3.88c0 .67-.558 1.212-1.246 1.212",
    fill: "#E1F8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.41 36.232H7.945c-.688 0-1.246.543-1.246 1.213v3.879c0 .513.328.952.79 1.129l11.354-6.144a1.254 1.254 0 00-.435-.077",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.178 42.537H7.946c-.688 0-1.246-.542-1.246-1.213v-3.88c0-.668.558-1.211 1.246-1.211h5.232v6.304zM18.41 42.537h-5.232v-6.304h5.232c.687 0 1.245.543 1.245 1.212v3.88c0 .67-.558 1.212-1.245 1.212z",
    stroke: "#076447",
    strokeWidth: 1.182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.481 16.961l-3.612-2.345a1.28 1.28 0 00-1.383 0l-3.611 2.345a1.204 1.204 0 00-.556 1.009v5.23c0 .67.558 1.212 1.246 1.212h7.225c.689 0 1.245-.542 1.245-1.212v-5.23c0-.405-.208-.784-.554-1.009",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.481 16.961l-3.612-2.345a1.28 1.28 0 00-1.383 0l-3.611 2.345a1.204 1.204 0 00-.556 1.009v5.23c0 .67.558 1.212 1.246 1.212h7.225c.689 0 1.245-.542 1.245-1.212v-5.23c0-.405-.208-.784-.554-1.009z",
    stroke: "#076447",
    strokeWidth: 1.182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.178 20.079c-.895 0-1.62.554-1.62 1.238v3.096h3.24v-3.096c0-.684-.726-1.238-1.62-1.238",
    fill: "#E1F8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.178 20.079c-.895 0-1.62.554-1.62 1.238v3.096h3.239v-3.096c0-.684-.725-1.238-1.62-1.238z",
    stroke: "#076447",
    strokeWidth: 1.182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.917 16.961l-3.612-2.345a1.28 1.28 0 00-1.383 0l-3.611 2.345a1.204 1.204 0 00-.556 1.009v5.23c0 .67.558 1.212 1.246 1.212h7.225c.689 0 1.246-.542 1.246-1.212v-5.23c0-.405-.208-.784-.555-1.009",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.917 16.961l-3.612-2.345a1.28 1.28 0 00-1.383 0l-3.611 2.345a1.204 1.204 0 00-.556 1.009v5.23c0 .67.558 1.212 1.246 1.212h7.225c.689 0 1.246-.542 1.246-1.212v-5.23c0-.405-.208-.784-.555-1.009z",
    stroke: "#076447",
    strokeWidth: 1.182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.614 20.079c-.894 0-1.62.554-1.62 1.238v3.096h3.24v-3.096c0-.684-.726-1.238-1.62-1.238",
    fill: "#E1F8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.614 20.079c-.895 0-1.62.554-1.62 1.238v3.096h3.24v-3.096c0-.684-.726-1.238-1.62-1.238z",
    stroke: "#076447",
    strokeWidth: 1.182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.659 50.417a.799.799 0 00-.81-.787h-9.716a.799.799 0 00-.81.787v2.364H36.66v-2.364z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.659 50.417a.799.799 0 00-.81-.787h-9.716a.799.799 0 00-.81.787v2.364H36.66v-2.364z",
    stroke: "#076447",
    strokeWidth: 1.182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.04 47.265a.799.799 0 00-.81-.788h-6.478a.799.799 0 00-.81.788v2.364h8.097v-2.364z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.04 47.265a.799.799 0 00-.81-.788h-6.478a.799.799 0 00-.81.788v2.364h8.097v-2.364z",
    stroke: "#076447",
    strokeWidth: 1.182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.145 42.537H43.68c-.688 0-1.246-.542-1.246-1.213v-3.88c0-.668.558-1.211 1.246-1.211h10.464c.687 0 1.245.543 1.245 1.212v3.88c0 .67-.558 1.212-1.245 1.212",
    fill: "#E1F8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.145 36.232H43.68c-.688 0-1.246.543-1.246 1.213v3.879c0 .513.328.952.79 1.129l11.354-6.144a1.254 1.254 0 00-.434-.077",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.913 42.537h-5.232c-.687 0-1.246-.542-1.246-1.213v-3.88c0-.668.559-1.211 1.246-1.211h5.232v6.304zM54.145 42.537h-5.232v-6.304h5.232c.688 0 1.246.543 1.246 1.212v3.88c0 .67-.558 1.212-1.246 1.212z",
    stroke: "#076447",
    strokeWidth: 1.182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
export default SvgIconMediumHome;